import {TextAnimations} from "./text-animation";
import {ImageReveal} from "./image-reveal";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import "./timeline-mksun";

gsap.registerPlugin(ScrollTrigger, SplitText);

window.addEventListener('load', () => {
    const sectionHeroEntreprise = document.querySelector('.mksun-hero--entreprise');
    if (sectionHeroEntreprise) {
        const TextAnimationHeroEntreprise = new TextAnimations([
            {
                selector: '.mksun-hero--entreprise h1',
                type: 'words',
                position: '>'
            }
        ], sectionHeroEntreprise, {});

        TextAnimationHeroEntreprise.init();

        TextAnimationHeroEntreprise.timeLine.from(
            '.mksun-hero--entreprise__content',
            {
                width: 0,
                duration: .5,
                ease: 'power1.in',
            })

        TextAnimationHeroEntreprise.timeLine.from('.mksun-hero--entreprise__content__text__advice',
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.in',
                stagger: 0.1
            });

        TextAnimationHeroEntreprise.animate();
    }

    const sectionEntreprisePrecurseur = document.querySelector('.mksun-block-precurseur');
    if (sectionEntreprisePrecurseur) {
        const TextAnimationEntreprisePrecurseur = new TextAnimations([
            {
                selector: '.mksun-block-precurseur .text-primary',
                type: 'words',
                position: '>'
            }, {
                selector: '.mksun-block-precurseur h2',
                type: 'words',
                position: '<'
            },
            {
                selector: '.mksun-block-precurseur__ctn__introduction__content__list li',
                type: 'lines',
                position: '<'
            }
        ], sectionEntreprisePrecurseur, {}, {
            start: "top 50%"
        });

        TextAnimationEntreprisePrecurseur.init();
        TextAnimationEntreprisePrecurseur.animate();

        TextAnimationEntreprisePrecurseur.timeLine.from(
            '.mksun-block-precurseur__ctn__introduction .btn',
            {
                y: 24,
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }, '<')

        const imageRevealEntreprisePrecurseur = new ImageReveal([
            {
                selector: '.mksun-block-precurseur__ctn__introduction__img',
                position: '>'
            }], TextAnimationEntreprisePrecurseur.timeLine);

        imageRevealEntreprisePrecurseur.init();
        imageRevealEntreprisePrecurseur.animate();

    }

    const sectionEntrepriseMission = document.querySelector('.mksun-mission--entreprise');
    if (sectionEntrepriseMission) {
        const TextAnimationEntrepriseMission = new TextAnimations([
            {
                selector: '.mksun-mission--entreprise p',
                type: 'words',
                position: '>'
            }
        ], sectionEntrepriseMission, {}, {
            start: "top 75%"
        });

        TextAnimationEntrepriseMission.init();
        TextAnimationEntrepriseMission.animate();


        const titleMission = new SplitText(
            '.mksun-mission--entreprise h2',
            {
                type: 'lines',
                linesClass: "line"
            }
        );

        titleMission.lines.forEach((line, index) => {
            const tlLine = gsap.timeline({
                scrollTrigger: {
                    trigger: line,
                    start: "top 75%",
                    end: "bottom 75%",
                    //scrub: true
                }
            });
            tlLine.fromTo(line, {
                backgroundSize: '100% 100%, 0% 100%',
                duration: 1,
            }, {
                backgroundSize: '0% 100%, 100% 100%',
            })
        })
    }

    const sectionEntrepriseEngagement = document.querySelector('.mksun-block--engagement');
    if (sectionEntrepriseEngagement) {
        const TextAnimationEntrepriseEngagement = new TextAnimations([
            {
                selector: '.mksun-block--engagement h2',
                type: 'words',
                position: '>'
            }
        ], sectionEntrepriseEngagement, {}, {
            start: "top 50%"
        });

        TextAnimationEntrepriseEngagement.init();
        TextAnimationEntrepriseEngagement.animate();

        TextAnimationEntrepriseEngagement.timeLine.from(
            '.mksun-block--engagement__ctn__grid__item', {
                y: 24,
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }
        )

        const imageRevealEntrepriseEngagement = new ImageReveal([
            {
                selector: '.mksun-block--engagement__ctn__video',
                position: '<',
                overlayColor: 'var(--primary-50)'
            }
        ], TextAnimationEntrepriseEngagement.timeLine);

        imageRevealEntrepriseEngagement.init();
        imageRevealEntrepriseEngagement.animate();
    }

    const sectionEntrepriseClients = document.querySelector('.mksun-client--entreprise');
    if(sectionEntrepriseClients) {
        const TextAnimationEntrepriseClients = new TextAnimations([
            {
                selector: '.mksun-client--entreprise h2',
                type: 'words',
                position: '>'
            }
        ], sectionEntrepriseClients, {}, {
            start: "top 50%"
        });

        TextAnimationEntrepriseClients.init();
        TextAnimationEntrepriseClients.animate();

        TextAnimationEntrepriseClients.timeLine.from(
            document.querySelectorAll('.mksun-client--entreprise__ctn__text__top, .mksun-client--entreprise__ctn__text__bottom'), {
                y: 24,
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }, "<"
        ).from(
            '.mksun-client--entreprise__ctn__advice__line__card', {
                y: 24,
                opacity: 0,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }, "<"
        )

    }


})